import {Component, Input, HostListener} from '@angular/core';

@Component({
  selector: 'nns-header-profile',
  template: `
    <div class="nns-header-profile-menu">
      <div class="nns-header-profile-button"
        title="Settings"
        (click)="toggle()"
      >
        <nns-icon icon="more-dark"></nns-icon>
      </div>

      <div class="nns-header-profile-dropdown">
        <div class="nns-header-profile-dropdown-inner">
          <nns-profile-more
            *ngIf="isVisibleDropdown && profile"
            [profile]="profile"
            [note]="note"
            [share]="share"
            [shareOrganization]="shareOrganization"
            [visual]="visual"
            [workspaces]="workspaces"
          ></nns-profile-more>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .nns-header-profile-menu {
      position:relative;
    }
    .nns-header-profile-dropdown {
      position:absolute;
      top:100%;
      right:0;
    }
    .nns-header-profile-dropdown-inner {
      padding:12px 0;
    }
    .nns-header-profile-button {
      display:block;
      cursor:pointer;
    }
    .nns-header-profile-button nns-icon{
      min-width: 16px;
      min-height: 16px;
    }
  `]
})

export class HeaderProfileComponent {
  @Input() public profile;
  @Input() public note;
  @Input() public share;
  @Input() public shareOrganization;
  @Input() public visual;
  @Input() public workspaces;
  isVisibleDropdown = false;

  toggle() {
    this.isVisibleDropdown = !this.isVisibleDropdown;
  }

  close() {
    this.isVisibleDropdown = false;
  }

  open() {
    this.isVisibleDropdown = true;
  }

  @HostListener('clickOutside', ['$event'])
  onClickOutside(event) {
    this.close();
  }

}
